
import { defineComponent, PropType } from "vue";

type LabelSize = "sm" | "md" | "bg";

export default defineComponent({
    name: "BlankImage",
    props: {
        size: {
            type: String as PropType<LabelSize>,
            default: "md",
        },
    },
});
